import React from 'react'

const BrandLogo = () => {
    return (
      <div>
        <img src="https://svgshare.com/i/fuM.svg" alt="Twispad Swap" width={200}/>
      </div>
    );
  };

  export default BrandLogo